import { observer } from "mobx-react";
import React, { Component } from "react";
import { FlexboxGrid, Icon, IconButton } from "rsuite";
import Col2 from "../../../../../Components/Columns/Col2";
import newDeliveryStore from "../../../../../Stores/AccountUpdated/Delivery/NewDeliveryStore";

class NextBackButton extends Component {
  render() {
    let step = this.props.step;
    let allsteps = this.props.allsteps;

    let nextBut = `Go to ${allsteps[step]} Details`;
    let backBut = `Back to ${allsteps[step - 2]} Details`;
    let disablenext = false;

    let del = newDeliveryStore.newdel;
    let maintype = newDeliveryStore.delCont.maintype;
    let from = del.fromaddress;
    let to = del.toaddress;

    if (step === 1) {
      backBut = "Back to Account";
      if (from.type === "") disablenext = true;
      if (from.city === "") disablenext = true;
      if (from.floor === "") disablenext = true;
      if (from.address === "") disablenext = true;
      if (from.name === "") disablenext = true;
      if (from.phone === "") disablenext = true;
    } else if (step === 2) {
      if (to.length <= 0) disablenext = true;
    } else if (step === 3) {
      if (del.jobdate === null) disablenext = true;
    } else if (step === 4) {
      if (maintype === "Fixed Per Type") {
        for (let i = 0; i < del.toaddress.length; i++) {
          if (del.toaddress[i].service === {}) disablenext = true;
          if (del.toaddress[i].service.type === "") disablenext = true;
          if (del.toaddress[i].service.type === undefined) disablenext = true;
        }
      } else {
        for (let i = 0; i < del.toaddress.length; i++) {
          if (del.toaddress[i].items.length <= 0) disablenext = true;
        }
      }
    } else if (step === 5) {
      for (let i = 0; i < del.addcharge.length; i++) {
        if (del.addcharge[i].name === "") disablenext = true;
        if (del.addcharge[i].price === "") disablenext = true;
        if (del.addcharge[i].price === 0) disablenext = true;
      }
    } else if (step === 6) {
      nextBut = "Create Order";
    }
    return (
      <div>
        <FlexboxGrid>
          <Col2>
            <IconButton
              icon={<Icon icon="left" />}
              color="red"
              block
              onClick={() => this.props.changeStep(-1)}
            >
              {backBut}
            </IconButton>
            <br />
          </Col2>
          <Col2>
            <IconButton
              icon={<Icon icon="right" />}
              color="green"
              block
              disabled={disablenext}
              onClick={() => {
                if (step === 1) newDeliveryStore.createNewOrder();
                if (step === 6) {
                  this.props.postNew();
                } else {
                  this.props.changeStep(1);
                }
              }}
              placement="right"
            >
              {nextBut}
            </IconButton>
          </Col2>
        </FlexboxGrid>
      </div>
    );
  }
}

export default observer(NextBackButton);
